"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PanelPeopleStyled = void 0;
const design_system_1 = require("@produits-internes-oss/design-system");
const Panel_1 = require("../../components/Panel/Panel");
const constants_1 = require("../../theme/constants");
exports.PanelPeopleStyled = styled(Panel_1.Panel) `
&.octo {
  padding: 0;

  >.track {
    overflow-x: auto;

    @media (min-width: ${constants_1.sizes.mobile}) {
      margin: 0 0.5em 0.5em;
    }

    @media (max-width: ${constants_1.sizes.mobile}) {
      margin: 0.5em;
    }

    > table {
      width: 100%;

      > thead {
        > tr {
          > th {
            vertical-align: middle;
            height: 2.5em;
            padding: 0.75em;
            color: ${design_system_1.theme.colors.marine[100]};
            font-weight: 600;

            @media (min-width: ${constants_1.sizes.mobile}) {
              display: table-cell;
            }

            @media (max-width: ${constants_1.sizes.mobile}) {
              display: none;
            }

            &:nth-child(n + 5) {
              @media (min-width: ${constants_1.sizes.tablet}) {
                display: table-cell;
              }

              @media (max-width: ${constants_1.sizes.tablet}) {
                display: none;
              }
            }
          }
        }
      }

      > tbody {
        > tr {
          > td {
            vertical-align: middle;
            height: 2.5em;
            padding: 0.75em;

            &:nth-child(n + 3) {
              @media (min-width: ${constants_1.sizes.mobile}) {
                display: table-cell;
              }

              @media (max-width: ${constants_1.sizes.mobile}) {
                display: none;
              }
            }

            &:nth-child(n + 5) {
              @media (min-width: ${constants_1.sizes.tablet}) {
                display: table-cell;
              }

              @media (max-width: ${constants_1.sizes.tablet}) {
                display: none;
              }
            }

            >.cell {
              display: flex;
              flex-flow: row wrap;
              align-items: center;
              justify-content: flex-start;

              > button {
                cursor: pointer;

                &:hover {
                  font-weight: 600;
                }

                > img {
                  width: 2.5em;
                  margin: 0 auto;
                  border-radius: 1.25em;
                }
              }
            }

            &.small {
              width: 5em;
            }

            &.compact {
              width: 8em;
            }

            &.large {
              width: 14em;
            }
          }

          &:nth-child(odd) {
            background-color: ${design_system_1.theme.colors.marine[5]};
          }
        }
      }
    }
  }
}
`;
//# sourceMappingURL=PanelPeople.styled.js.map